import { render, staticRenderFns } from "./PopUpSendForm.vue?vue&type=template&id=b3e90a68&scoped=true&"
import script from "./PopUpSendForm.vue?vue&type=script&lang=js&"
export * from "./PopUpSendForm.vue?vue&type=script&lang=js&"
import style0 from "./PopUpSendForm.vue?vue&type=style&index=0&id=b3e90a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e90a68",
  null
  
)

export default component.exports